module.exports = __webpack_public_path__ + "static/media/create-white.78fb33ba.svg";